import type { IconSvgObject } from './types';

const TextCreationIcon: IconSvgObject = [
  ["path", { d: "M18 2.00001L21.9999 2L22 6H18.0002L18 2.00001Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2.00001L5.99991 2L6 6H2.00023L2 2.00001Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 18H5.99991L6 22H2.00023L2 18Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18 18H21.9999L22 22H18.0002L18 18Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M20 18V6M6 20H18M18 4H6M4 6V18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M13.5 16H10.5M12 8L12 16M8 9.5V9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9V9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default TextCreationIcon;
